import {PropsWithChildren, useMemo, useRef} from 'react';
import {VerificationCompletedModal} from './VerificationCompletedModal';
import {PostHandler, VerificationCompletedContext} from './context';
import {useModalControls} from '@chekinapp/ui';

export const VerificationCompletedProvider = ({children}: PropsWithChildren) => {
  const {isOpen, closeModal, openModal} = useModalControls();
  const postHandlerRef = useRef<PostHandler>();

  const value = useMemo(
    () => ({
      closeModal,
      openModal: (proceed: PostHandler) => {
        postHandlerRef.current = proceed;
        openModal();
      },
      proceed: () => postHandlerRef.current?.(),
    }),
    [closeModal, openModal],
  );

  return (
    <VerificationCompletedContext.Provider value={value}>
      {children}
      <VerificationCompletedModal open={isOpen} />
    </VerificationCompletedContext.Provider>
  );
};
